/* eslint-disable react-hooks/exhaustive-deps */
import { useEffect, useState } from "react";

import { useDispatch, useSelector } from "react-redux";
import { useLocation, useNavigate, useParams } from "react-router-dom";

import StatusContainer from "../../../../../components/_utils/CommonStatus/StatusContainer";
import InfoCard from "../../../../../components/_utils/CommonStatus/StatusSubComponents/StatusCardContainer/InfoCard";
import TabsWeapperSection from "../../../../../components/_utils/CommonStatus/StatusSubComponents/TabsWrapperSection";
import { viewAccountDetail } from "../../../../../redux/features/accounts/ReimburseAccount";
import { setHideBreadCrumb } from "../../../../../redux/features/hideBreadCrumb/hideBreadCrumb";
import { GlobalConfiguration } from "../../../../../utils/configurationProvider";

const ReimbursementCategoriesSucess = (props) => {
  const navigate = useNavigate();
  const dispatch = useDispatch();
  const location = useLocation();
  const { id } = useParams();
  const updatedFields = location?.state?.updatedFields || [];
  const { viewAccountDetailData, viewAccountDetailError } = useSelector(
    (state) => state.ReimburseAccount,
  );

  useEffect(() => {
    dispatch(setHideBreadCrumb({ hide: true }));

    return () => {
      dispatch(setHideBreadCrumb({ hide: false }));
    };
  }, [dispatch]);

  const [currentAccountDetails, setCurrentAccountDetails] = useState({
    id: "",
    name: "",
    bank_name: "",
    bank_acc_no: "",
    ifsc_code: "",
    category: "",
    pan: "",
    labels: [],
    bank_account_holder_full_name: "",
  });

  const viewDetailsHandler = () => {
    navigate(
      `/reimbursement_account_dashboard/reimbursement_account_view_all/reimbursement_account_detail_page/${id}`,
    );
  };
  const dashboardHandler = () => {
    navigate("/reimbursement_account_dashboard");
  };

  const createTxn = () => {
    navigate(
      "/reimbursement_transaction_dashboard/create_reimbursement_transactions",
      {
        state: currentAccountDetails,
      },
    );
  };

  const beneficiaryAccount = viewAccountDetailData?.reimbursement_accounts?.[0];

  const fieldsToShow =
    updatedFields.length > GlobalConfiguration.lengthCheckZero
      ? updatedFields
      : ["category"];

  const fieldConfig = {
    account_name: {
      leftSubTitle: "Account name",
      getTitle: (acc) =>
        acc?.name ? acc?.name?.toLowerCase() : "Not available",
    },
    category: {
      leftSubTitle: "Assigned categories",
      hoverable: "black",
      getTitle: (acc) =>
        typeof acc?.category === "string"
          ? acc.category
              .split(",")
              .map((cat) => cat.trim())
              .join(" , ")
          : acc?.category,
    },
  };

  const renderInfoCards = () => {
    return fieldsToShow
      .filter((key) => fieldConfig[key])
      .map((key) => {
        const config = fieldConfig[key];
        return (
          <InfoCard
            key={key}
            bgColor="var(--positive-card)"
            hoverable={config.hoverable}
            rows={[
              {
                leftTitle: config.getTitle(beneficiaryAccount),
                leftSubTitle: config.leftSubTitle,
              },
            ]}
          />
        );
      });
  };

  useEffect(() => {
    if (viewAccountDetailError) {
      navigate("*");
    }
  }, [viewAccountDetailError]);

  useEffect(() => {
    dispatch(viewAccountDetail({ id }));
  }, [dispatch, id]);

  const successAccountId =
    viewAccountDetailData?.reimbursement_accounts?.[0]?.id;
  useEffect(() => {
    const account = viewAccountDetailData?.reimbursement_accounts?.[0];
    if (account) {
      const {
        id: accId,
        name,
        bank_name,
        bank_acc_no,
        ifsc_code,
        category,
        pan_no,
        labels,
      } = account;
      setCurrentAccountDetails({
        id: accId,
        name,
        bank_name,
        bank_acc_no,
        ifsc_code,
        category,
        pan: pan_no,
        labels: labels || [],
        bank_account_holder_full_name: name,
      });
    }
  }, [successAccountId]);

  const buttonRows = [
    [
      {
        btnText: "Create account",
        enabledBgColor: "var(--text-primary)",
        enabledTextColor: "var(--positive-bg)",
        icon: "https://q2pay.in/new_assets/common/create_flow/create_new_account.svg",
        handleFunction: () => {
          navigate(
            `/reimbursement_account_dashboard/create_reimbursement_account`,
          );
        },
        iconToBeAlign: "left",
        fullWidthRequired: true,
        imgColor: "var(--positive-bg)",
      },
      {
        btnText: "Create transaction",
        enabledBgColor: "var(--text-primary)",
        enabledTextColor: "var(--positive-bg)",
        icon: "https://q2pay.in/new_assets/common/settings/add_button_white.svg",
        handleFunction: createTxn,
        iconToBeAlign: "left",
        fullWidthRequired: true,
        imgColor: "var(--positive-bg)",
      },

      {
        btnText: "View details",
        enabledBgColor: "var(--text-primary)",
        enabledTextColor: "var(--positive-bg)",
        icon: "https://q2pay.in/new_assets/common/create_flow/view_details.svg",
        handleFunction: viewDetailsHandler,
        iconToBeAlign: "left",
        fullWidthRequired: true,
        imgColor: "var(--positive-bg)",
      },
    ],
    [
      {
        btnText: "Go to dashboard",
        enabledBgColor: "var(--bg-positive-bg)",
        enabledTextColor: "var(--text-primary)",
        icon: "https://q2pay.in/new_assets/common/dashboard/dashboard.svg",
        handleFunction: dashboardHandler,
        iconToBeAlign: "left",
        fullWidthRequired: true,
        outLineColor: "var(--text-primary)",
        hoverOption: "white",
      },
    ],
  ];

  return (
    <>
      <StatusContainer
        status="success"
        hoverOption="white"
        buttonRows={buttonRows}
        title="Category updated successfully."
      >
        <TabsWeapperSection title="Account details">
          <>{renderInfoCards()}</>
        </TabsWeapperSection>
      </StatusContainer>
    </>
  );
};

export default ReimbursementCategoriesSucess;
